import createBreakpoint from 'shared-tokens/utils/breakpoints';

const brpM = createBreakpoint('m');

export const mainCls = 'hamb';
export default {
  [mainCls]: {
    position: 'relative',
    display: 'block',
    width: 28,
    height: 2,
    transitionTimingFunction: 'cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    transitionDuration: '.22s',
    pointerEvents: 'none',
    [brpM]: {
      width: 25,
    },
  },
  [`${mainCls}__i`]: {
    position: 'absolute',
    top: 0,
    left: -1,
    display: 'block',
    margin: 0,
    padding: 0,
    width: '100% !important',
    height: '2px !important',
    transform: 'scale(1.3, 1)',
    transition: 'top 0.1s ease-in .25s, bottom 0.1s ease-in 0.25s, opacity .1s ease-in, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19)',
    [brpM]: {
      left: 0,
      transform: 'none',
    },
  },
  [`${mainCls}__i-t`]: {
    top: '-10px',
    [brpM]: {
      top: '-8px',
    },
  },
  [`${mainCls}__i-b`]: {
    top: '10px',
    [brpM]: {
      top: '8px',
    },
  },
  [`${mainCls}--opn`]: {
    transform: 'rotate(225deg)',
    [`& .${mainCls}__i`]: {
      transform: 'none',
    },
    [`& .${mainCls}__i-t`]: {
      top: 0,
      transition: 'top 0.1s ease-out, opacity 0.1s ease-out .12s',
      opacity: '0',
    },
    [`& .${mainCls}__i-b`]: {
      top: 0,
      transform: 'rotate(-90deg)',
      transition: 'bottom .1s ease-out,transform .22s cubic-bezier(.215,.61,.355,1) .12s',
    },
  },
};